import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import cacheLocation from './cacheLocation';
import geoCode from './geoCode';
import getLocationFromApi from './getLocationApi';
import notifyNewrelic from './notifyNewrelic';
import onPositionFailed from './onPositionFailed';

const onPositionSuccess = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* ({
    position,
    apiKey,
    secondaryLocationApi,
    shouldLogNewrelic,
    cacheDuration
  }) {
    if (position && position.coords && apiKey) {
      const _position$coords = position.coords,
            latitude = _position$coords.latitude,
            longitude = _position$coords.longitude;

      try {
        const result = yield geoCode({
          latitude,
          longitude,
          apiKey
        });

        if (result.success) {
          cacheLocation(result.location, cacheDuration);
          document.dispatchEvent(new CustomEvent('location', {
            detail: result
          }));
          return result;
        }

        return onPositionFailed({
          code: 4
        }, shouldLogNewrelic, secondaryLocationApi, cacheDuration);
      } catch (e) {
        return onPositionFailed({
          code: 4
        }, shouldLogNewrelic, secondaryLocationApi, cacheDuration);
      }
    }

    return getLocationFromApi(secondaryLocationApi, cacheDuration, shouldLogNewrelic);
  });

  return function onPositionSuccess(_x) {
    return _ref.apply(this, arguments);
  };
}();

const getPositionFromBrowser = (googleMapApiKey, shouldLogNewrelic, locationTimeout, secondaryLocationApi, cacheDuration) => {
  const options = {
    maximumAge: cacheDuration * 24 * 60 * 60 * 1000,
    timeout: locationTimeout
  };
  const timeout = setTimeout(onPositionFailed, locationTimeout, {
    code: 2
  }, shouldLogNewrelic, secondaryLocationApi, cacheDuration);
  return new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(position => {
      clearTimeout(timeout);
      notifyNewrelic(shouldLogNewrelic, 'Allowed', 'Browser', 'Location allowed on browser');
      return resolve(onPositionSuccess({
        position,
        apiKey: googleMapApiKey,
        secondaryLocationApi,
        shouldLogNewrelic,
        cacheDuration
      }));
    }, error => {
      clearTimeout(timeout);
      return resolve(onPositionFailed(error, shouldLogNewrelic, secondaryLocationApi, cacheDuration));
    }, options);
  });
};

const getCurrentLocation = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* ({
    googleMapApiKey,
    shouldLogNewrelic = false,
    locationTimeout = 10000,
    cacheDuration = 7,
    secondaryLocationApi
  }) {
    const savedLocation = JSON.parse(window.localStorage.getItem('location'));

    if (savedLocation && savedLocation.expireAt > Date.now()) {
      const locationResult = {
        success: true,
        location: savedLocation.location
      };
      document.dispatchEvent(new CustomEvent('location', {
        detail: locationResult
      }));
      notifyNewrelic(shouldLogNewrelic, 'Success', 'Cache', 'Location obtained from cache');
      return locationResult;
    }

    if (navigator.geolocation) {
      return getPositionFromBrowser(googleMapApiKey, shouldLogNewrelic, locationTimeout, secondaryLocationApi, cacheDuration);
    }

    return onPositionFailed({
      code: 5
    }, shouldLogNewrelic, secondaryLocationApi, cacheDuration);
  });

  return function getCurrentLocation(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

export default getCurrentLocation;